import { useMemo } from 'react';
import { SessionStateKeys } from '../../models/session-state-keys';
import LowerApi from '../../modules/lower-api';
import AppConfig from '../../config/app-config';
import { GetEncodedValueFromSession } from '../../modules/lower-ui-kit/lib/session-storage/session-storage-utils';

export const useLowerApi = () => useMemo(() => ({
  get lowerApi() {
    return new LowerApi({
      get authCode() {
        return GetEncodedValueFromSession(SessionStateKeys.UserCode);
      },
      baseEndpoint: AppConfig.Endpoints.Base,
    });
  },
}), []);
